import { render, staticRenderFns } from "./IncompleteReleaseWarningDialog.vue?vue&type=template&id=64a8853b"
import script from "./IncompleteReleaseWarningDialog.vue?vue&type=script&lang=ts"
export * from "./IncompleteReleaseWarningDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports